import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { clearChangeEmail } from 'redux/users/actions';
import { logout } from 'redux/users/actions';

import Button from 'components/elements/buttons/Button';
import ChangeEmailModal
  from 'components/dashboard/security-content/ChangeEmailModal';

import './ChangeEmail.css';

function ChangeEmail({ me, clearChangeEmail, logout, changeEmailSuccess }) {
  const [modalOpen, setModalOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="change-email__component">
      <div className="wrapper">
        <div className="email">
          <div className="label">{t("Current Email")}</div>
          <div className="value">{me.email}</div>
        </div>
        <Button
          small
          onClick={() => setModalOpen(true) }
        >
          {t("Change")}
        </Button>
      </div>

      {/* Change Email Modal */}
      <ChangeEmailModal
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
          if (changeEmailSuccess) {
            clearChangeEmail();
            logout();
          }
        }}
      />
    </div>
  );
}

ChangeEmail.propTypes = {
  clearChangeEmail: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  me: PropTypes.object,
  changeEmailSuccess: PropTypes.object,
};

ChangeEmail.defaultProps = {
  me: null,
  changeEmailSuccess: null,
};


const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    changeEmailSuccess: state.usersReducer.changeEmailSuccess,
  }
);

export default connect(
  mapStateToProps,
  {
    clearChangeEmail,
    logout,
  },
)(ChangeEmail);
